import { FC } from "react";
import { useTranslation } from "react-i18next";

import { StationRouteHtmlInfoContainerStyled } from "./station-route.styled";

interface IStationRouteBannerProps {
  isCustomized?: boolean;
}

export const StationRouteBanner: FC<IStationRouteBannerProps> = ({
  isCustomized,
}) => {
  const { t } = useTranslation();
  const titleKey = isCustomized
    ? "stationRoute.CUSTOMIZED_BANNER_TITLE"
    : "stationRoute.BANNER_TITLE";
  const textKey = isCustomized
    ? "stationRoute.CUSTOMIZED_BANNER_TEXT"
    : "stationRoute.BANNER_TEXT";

  return (
    <StationRouteHtmlInfoContainerStyled
      className={isCustomized ? "is-customized" : undefined}
    >
      <div className="banner__info">
        <h2 className="banner__info-title">{t(titleKey)}</h2>
        <p className="banner__info-text">{t(textKey)}</p>
      </div>
    </StationRouteHtmlInfoContainerStyled>
  );
};
